var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0005 12C20.0005 16.4183 16.4188 20 12.0005 20C7.58221 20 4.00049 16.4183 4.00049 12C4.00049 7.58172 7.58221 4 12.0005 4C16.4188 4 20.0005 7.58172 20.0005 12ZM22.0005 12C22.0005 17.5228 17.5233 22 12.0005 22C6.47764 22 2.00049 17.5228 2.00049 12C2.00049 6.47715 6.47764 2 12.0005 2C17.5233 2 22.0005 6.47715 22.0005 12ZM17.0005 13.5C17.8289 13.5 18.5005 12.8284 18.5005 12C18.5005 11.1716 17.8289 10.5 17.0005 10.5C16.1721 10.5 15.5005 11.1716 15.5005 12C15.5005 12.8284 16.1721 13.5 17.0005 13.5ZM13.5011 12C13.5011 12.8284 12.8296 13.5 12.0011 13.5C11.1727 13.5 10.5011 12.8284 10.5011 12C10.5011 11.1716 11.1727 10.5 12.0011 10.5C12.8296 10.5 13.5011 11.1716 13.5011 12ZM7.00081 13.5C7.82924 13.5 8.50081 12.8284 8.50081 12C8.50081 11.1716 7.82924 10.5 7.00081 10.5C6.17239 10.5 5.50081 11.1716 5.50081 12C5.50081 12.8284 6.17239 13.5 7.00081 13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsCircle);
export default __webpack_public_path__ + "static/media/dots-circle.bf43e4b6eec6579cbb718d2fdb098a2c.svg";
export { ForwardRef as ReactComponent };